import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        border: '1px solid',
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main
    },
    videoCard: {
        display: 'flex',
        flexDirection: 'row'
    },
    thumbnailTranscoding: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: '1px solid',
        width: 160,
        height: 120,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 'bold'
    },
    videoCardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: "start",
        alignItems: 'start',
        width: "100%",
        padding: 0,
        paddingLeft: 8
    },
    discipline: {
        color: theme.palette.text.primary,
        textAlign: "left",
        fontWeight: "bolder",
        paddingLeft: 10,
        fontSize: (props) => props.headerSize ? props.headerSize : 16
    },
    description: {
        color: theme.palette.text.secondary,
        textAlign: "left",
        fontSize: (props) => props.textSize ? props.textSize : 14,
        paddingTop: 10,
        paddingLeft: 10
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: "center"
    },
    spacedRow: {
        width: "100%",
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center"
    }
}));

export {useStyles};
